"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorTranslationContext = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var Yup = __importStar(require("yup"));
var AnalyticsContext_1 = __importDefault(require("../context/AnalyticsContext"));
exports.ErrorTranslationContext = react_1.default.createContext(function (key) { return key; });
// function deepTranslateValues<StringOrTranslationKey extends string>(
//   input: any,
//   translate: (k: StringOrTranslationKey) => string
// ): any {
//   try {
//     if (typeof input === "string") return translate(input as any)
//     if (typeof input !== "object") return input
//     if (Array.isArray(input)) {
//       return input.map((li) => deepTranslateValues(li, translate))
//     }
//     return mapValues(input, (value) => {
//       return deepTranslateValues(value, translate)
//     })
//   } catch (error) {
//     console.error("deepTranslateValues error", error)
//     return input
//   }
// }
// function useTranslatedErrors<
//   Values extends FormikValues,
//   StringOrTranslationKey extends string
// >(
//   errors: FormikErrors<Values>,
//   translate?: (tk: StringOrTranslationKey) => string
// ) {
//   const translatedErrors: FormikErrors<Values> = React.useMemo(() => {
//     if (!translate) return errors
//     return deepTranslateValues(errors, translate)
//   }, [errors, translate])
//   console.log({ errors, translatedErrors })
//   return translatedErrors
// }
// let InnerForm = <
//   Values extends FormikValues,
//   StringOrTranslationKey extends string
// >(props: {
//   formikProps: FormikProps<Values>
//   submitError: Maybe<StringOrTranslationKey>
//   children: FormChildren<Values>
//   translate?: (tk: StringOrTranslationKey) => string
//   className?: string
// }) => {
//   const { formikProps, submitError, children, translate, className } = props
//   const formatted = {
//     errors: useTranslatedErrors(formikProps.errors, translate),
//     submitError: translate && submitError ? translate(submitError) : submitError
//   }
//   const els = children({ ...formikProps, ...formatted })
//   console.log({ els })
//   return <Form className={className}>{els}</Form>
// }
// InnerForm = React.memo(InnerForm)
var FormWrapper = function (props) {
    var initialValues = props.initialValues, onSubmit = props.onSubmit, children = props.children, validationSchema = props.validationSchema, lazyValidationSchema = props.lazyValidationSchema, unhandledErrorMessage = props.unhandledErrorMessage, className = props.className, submitTrackEvent = props.submitTrackEvent, translateError = props.translateError;
    var track = react_1.default.useContext(AnalyticsContext_1.default).track;
    var _a = react_1.default.useState(), submitError = _a[0], setSubmitError = _a[1];
    // const renderChildren = (fp: FormikProps<Values>): React.ReactNode => {
    //   return <Form className={className}>{children({ ...fp, submitError })}</Form>
    // }
    var renderChildren = react_1.default.useCallback(function (formikProps) {
        var formEl = (react_1.default.createElement(formik_1.Form, { className: className, children: children(__assign(__assign({}, formikProps), { submitError: translateError && submitError
                    ? translateError(submitError)
                    : submitError })) }));
        if (translateError) {
            return (react_1.default.createElement(exports.ErrorTranslationContext.Provider, { value: translateError }, formEl));
        }
        else {
            return formEl;
        }
    }, [submitError, translateError, className, children]);
    var formattedValidationSchema = react_1.default.useMemo(function () {
        return (lazyValidationSchema ||
            (validationSchema ? Yup.object().shape(validationSchema) : undefined));
    }, [validationSchema, lazyValidationSchema]);
    var handleSubmit = react_1.default.useCallback(function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var setSubmitting, error, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (submitTrackEvent)
                        track(submitTrackEvent);
                    setSubmitting = formikHelpers.setSubmitting;
                    setSubmitError(undefined);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onSubmit(values)];
                case 2:
                    error = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    if (unhandledErrorMessage)
                        error = unhandledErrorMessage;
                    return [3 /*break*/, 4];
                case 4:
                    if (error)
                        setSubmitError(error);
                    setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); }, [setSubmitError, onSubmit]);
    var formikProps = {
        initialValues: initialValues,
        children: renderChildren,
        validationSchema: formattedValidationSchema,
        onSubmit: handleSubmit
    };
    return react_1.default.createElement(formik_1.Formik, __assign({}, formikProps));
};
exports.default = FormWrapper;
